import { IRoute } from '@/hooks/useMenu'
import React from 'react'
import { Dropdown as BootstrapDropdown } from 'react-bootstrap'
import { MdExpandLess, MdExpandMore } from 'react-icons/md'

import { HighlightedTitle, MenuItem } from './item'
import { isRouteActive } from './utils'

interface IProps {
  route: IRoute
  open: boolean
  setOpen: () => void
  /** Grupo expandido no momento — é ele que recebe o destaque. */
  isActive: boolean
  activeRoute: string | null
  searchTerm?: string
  isPinned: (route: string) => boolean
  onNavigate: (route: string) => void
  onTogglePin: (route: string) => void
}

export const Dropdown: React.FC<IProps> = ({
  route,
  open,
  setOpen,
  isActive,
  activeRoute,
  searchTerm,
  isPinned,
  onNavigate,
  onTogglePin
}) => {
  return (
    <div className="drop_container">
      <button
        type="button"
        onClick={() => setOpen()}
        className={`group_toggle ${isActive ? 'is-active' : ''}`}
        aria-expanded={open}
      >
        {route.icon}
        <strong className="desc">
          <HighlightedTitle title={route.title} searchTerm={searchTerm} />
        </strong>
        <span className="arrow">
          {open ? <MdExpandLess /> : <MdExpandMore />}
        </span>
      </button>
      {open && (
        <div className="dropdown-options">
          {route?.options?.map(option => {
            if (option.options) {
              return (
                <BootstrapDropdown className="mt-0 mb-0 p-0" key={option.title}>
                  <BootstrapDropdown.Toggle variant="none">
                    <HighlightedTitle
                      title={option.title}
                      searchTerm={searchTerm}
                    />
                  </BootstrapDropdown.Toggle>
                  <BootstrapDropdown.Menu style={{ zIndex: 9999999999999 }}>
                    {option.options.map(o => (
                      <MenuItem
                        key={o.route}
                        route={o.route}
                        title={o.title}
                        isActive={isRouteActive(o.route, activeRoute || '')}
                        isPinned={isPinned(o.route)}
                        searchTerm={searchTerm}
                        onNavigate={onNavigate}
                        onTogglePin={onTogglePin}
                      />
                    ))}
                  </BootstrapDropdown.Menu>
                </BootstrapDropdown>
              )
            }
            return (
              <MenuItem
                key={option.route}
                route={option.route}
                title={option.title}
                isActive={option.route === activeRoute}
                isPinned={isPinned(option.route)}
                searchTerm={searchTerm}
                onNavigate={onNavigate}
                onTogglePin={onTogglePin}
              />
            )
          })}
        </div>
      )}
    </div>
  )
}
